import { render, staticRenderFns } from "./BandejaEmbajadorHallazgoRechazadosPendientes.vue?vue&type=template&id=b28f07f0"
import script from "./BandejaEmbajadorHallazgoRechazadosPendientes.vue?vue&type=script&lang=js"
export * from "./BandejaEmbajadorHallazgoRechazadosPendientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports